<template>
  <!-- screen used for when the token is expired, right after is directed to login -->
  <div class="container-fluid py-5 background-login">
    <div class="row row-style">
      <div class="col-sm-9 col-md-7 col-lg-4 mx-auto div-url">
        <h5 style="font-size: 65px; padding: 40px">OPS...</h5>

        <h4 class="card-title text-center text-join">Página não encontrada!</h4>
        <h6 class="card-title text-join">
          Certifique-se de que o grupo foi digitado corretamente na url.
        </h6>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "WrongUrl",
  data() {
    return {};
  },

  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-url {
  background: rgba(255, 255, 255, 0.8);
  border: none;
  margin-top: 5%;
  border-radius: 12px;
}
.background-login {
  height: 100%; /* Center and scale the image nicely */
  background-repeat: no-repeat center;
  background-size: cover;
}
.row-style {
  width: 100%;
  height: 450px;
  margin-left: 0px !important;
}
.logo-image {
  width: 100%;
  max-width: 240px;
}

.text-join {
  color: rgb(100, 95, 95);
  margin-top: 5px;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/WrongUrl.vue